(() => {
  'use strict';
  const VERSION = '2026-09-06-v4-modal-transition-close-owner';
  if (window.__SQ_UNIVERSAL_BAG_CLOSEOUT__ === VERSION) return;
  window.__SQ_UNIVERSAL_BAG_CLOSEOUT__ = VERSION;

  const BAG = '.sq-universal-bag';
  const MODAL = '[data-sq-universal-expanded-root] [data-lcs-favorite-expanded], [data-lcs-favorite-expanded]';
  const CLOSE = '[data-lcs-expanded-close], [data-lcs-favorite-expanded] .lcs-favorite-expanded__overlay, [data-premium-expanded-close]';
  const CARD = '.sq-universal-card,[data-sq-universal-card],product-card,.product-card,.product-slider-belt-card,.sq-smart-picks__item,[data-lcs-favorite-card],[data-sqyml2-card],[data-lcs-recommend-card],[data-product-id],.premium-recommend-card-shell,.sq-search-card,.sq-search-grid-card,.predictive-search__product-card';
  const OPEN_CLASSES = ['sq-bag-expanded','sq-bag-pill-expanded','sq-universal-bag-expanded','sq-bag-card-active','is-open','is-active','is-expanded','is-sq-bag-intent','sq-bag-closeout-suppressed'];
  const INLINE_EXPANSION_PROPS = ['width','min-width','max-width','padding-left','padding-right','padding-inline','gap','justify-content'];
  let patchedController = null;
  let modalWasOpen = false;
  let closeFrame = 0;

  const isExternalBag = (bag) => bag instanceof HTMLButtonElement && !bag.closest(MODAL);
  const cardFor = (bag) => bag?.closest?.(CARD) || null;
  const modalOpen = () => [...document.querySelectorAll(MODAL)].some((modal) => {
    if (!(modal instanceof HTMLElement) || modal.hidden) return false;
    if (modal.getAttribute('aria-hidden') === 'true') return false;
    const style = getComputedStyle(modal);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0;
  });

  const forceCircle = (bag, hold = true) => {
    if (!isExternalBag(bag)) return;
    OPEN_CLASSES.forEach((className) => bag.classList.remove(className));
    INLINE_EXPANSION_PROPS.forEach((property) => bag.style.removeProperty(property));
    bag.removeAttribute('data-sq-bag-intent');
    delete bag.dataset.sqBagIntent;
    delete bag.dataset.sqBagCloseout;
    bag.setAttribute('aria-expanded', 'false');
    bag.setAttribute('aria-pressed', 'false');
    bag.classList.toggle('sq-bag-just-closed', hold);
    if (document.activeElement === bag) {
      try { bag.blur(); } catch (_) {}
    }
  };

  const allBags = () => [...document.querySelectorAll(BAG)].filter(isExternalBag);
  const collapseAll = (hold = true) => allBags().forEach((bag) => forceCircle(bag, hold));

  const releaseWhenOutside = () => {
    allBags().forEach((bag) => {
      if (!bag.classList.contains('sq-bag-just-closed')) return;
      const card = cardFor(bag);
      const stillIntent = Boolean(card?.matches(':hover,:focus-within') || bag.matches(':hover,:focus-visible'));
      if (!stillIntent && !modalOpen()) bag.classList.remove('sq-bag-just-closed');
    });
  };

  const closeout = () => {
    collapseAll(true);
    if (closeFrame) cancelAnimationFrame(closeFrame);
    closeFrame = requestAnimationFrame(() => {
      closeFrame = 0;
      collapseAll(true);
    });
    setTimeout(() => collapseAll(true), 60);
    setTimeout(() => collapseAll(true), 160);
    setTimeout(releaseWhenOutside, 280);
  };

  const installStyle = () => {
    if (document.getElementById('sq-universal-bag-closeout-style-v4')) return;
    const style = document.createElement('style');
    style.id = 'sq-universal-bag-closeout-style-v4';
    style.textContent = `
      html body .sq-universal-bag.sq-bag-just-closed,
      html body .sq-universal-bag.sq-bag-just-closed:hover,
      html body .sq-universal-bag.sq-bag-just-closed:focus,
      html body .sq-universal-bag.sq-bag-just-closed:focus-visible,
      html body .sq-universal-bag.sq-bag-just-closed:active,
      html body .sq-universal-bag.sq-bag-just-closed[aria-expanded='true']{
        width:var(--sq-size,42px)!important;
        min-width:var(--sq-size,42px)!important;
        max-width:var(--sq-size,42px)!important;
        padding:0!important;
        gap:0!important;
        justify-content:center!important;
        border-radius:999px!important;
        transform:none!important;
      }
      html body .sq-universal-bag.sq-bag-just-closed .sq-universal-bag__icon{
        left:50%!important;
        transform:translate(-50%,-50%)!important;
      }
      html body .sq-universal-bag.sq-bag-just-closed .sq-universal-bag__label{
        opacity:0!important;
        visibility:hidden!important;
        width:0!important;
        max-width:0!important;
        margin:0!important;
        padding:0!important;
        overflow:hidden!important;
        pointer-events:none!important;
      }
    `;
    document.head.appendChild(style);
  };

  const patchController = () => {
    const controller = window.SQUniversalExpanded;
    if (!controller || controller === patchedController || typeof controller !== 'object') return;
    patchedController = controller;

    if (typeof controller.openExpanded === 'function' && !controller.openExpanded.__sqBagCloseoutWrappedV4) {
      const originalOpen = controller.openExpanded.bind(controller);
      const wrappedOpen = (...args) => {
        collapseAll(true);
        const result = originalOpen(...args);
        requestAnimationFrame(() => collapseAll(true));
        modalWasOpen = true;
        return result;
      };
      wrappedOpen.__sqBagCloseoutWrappedV4 = true;
      controller.openExpanded = wrappedOpen;
    }

    if (typeof controller.closeExpanded === 'function' && !controller.closeExpanded.__sqBagCloseoutWrappedV4) {
      const originalClose = controller.closeExpanded.bind(controller);
      const wrappedClose = (...args) => {
        const result = originalClose(...args);
        modalWasOpen = false;
        closeout();
        return result;
      };
      wrappedClose.__sqBagCloseoutWrappedV4 = true;
      controller.closeExpanded = wrappedClose;
    }
  };

  const reconcileModalState = () => {
    patchController();
    const openNow = modalOpen();
    if (modalWasOpen && !openNow) closeout();
    modalWasOpen = openNow;
    if (!openNow) releaseWhenOutside();
  };

  const run = () => {
    installStyle();
    patchController();
    modalWasOpen = modalOpen();
    if (!modalWasOpen) releaseWhenOutside();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  const observer = new MutationObserver(() => requestAnimationFrame(reconcileModalState));
  observer.observe(document.documentElement, {
    childList:true,
    subtree:true,
    attributes:true,
    attributeFilter:['hidden','aria-hidden','class','style','open']
  });

  document.addEventListener('pointerdown', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (target?.closest(CLOSE)) {
      setTimeout(closeout, 0);
      return;
    }
    const bag = target?.closest(BAG);
    if (isExternalBag(bag)) bag.classList.remove('sq-bag-just-closed');
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (target?.closest(CLOSE)) setTimeout(closeout, 0);
  }, true);

  document.addEventListener('pointerout', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const card = target?.closest(CARD);
    if (!(card instanceof Element)) return;
    if (event.relatedTarget instanceof Node && card.contains(event.relatedTarget)) return;
    card.querySelectorAll(BAG).forEach((bag) => {
      if (isExternalBag(bag)) bag.classList.remove('sq-bag-just-closed');
    });
  }, true);

  document.addEventListener('focusout', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const card = target?.closest(CARD);
    if (!(card instanceof Element)) return;
    if (event.relatedTarget instanceof Node && card.contains(event.relatedTarget)) return;
    card.querySelectorAll(BAG).forEach((bag) => {
      if (isExternalBag(bag)) bag.classList.remove('sq-bag-just-closed');
    });
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modalOpen()) setTimeout(closeout, 0);
  }, true);

  ['sq:expanded-card-closed','sq:expanded-close','sq:universal-expanded-closed'].forEach((name) => {
    document.addEventListener(name, closeout);
  });

  window.SQUniversalBagCloseout = { forceCircle, collapseAll, closeout, releaseWhenOutside, reconcileModalState };
})();
